import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { UserLoginPage } from "./user-login/user-login.page";
import { LoginOTPComponent } from "./login-otp/login-otp.component";

const routes: Routes = [
  {
    path: "",
    component: UserLoginPage,
  },

  {
    path: "otp-login",
    component: LoginOTPComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserLoginPageRoutingModule {}
